import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isHome = location.pathname === '/';
  const bgClass = isHome
    ? scrolled
      ? 'fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md transition-all duration-300'
      : 'absolute top-0 left-0 right-0 z-50 bg-transparent transition-all duration-300'
    : 'sticky top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md';

  const textClass = isHome && !scrolled ? 'text-white' : 'text-foreground-900';

  return (
    <nav className={bgClass}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 ${textClass}`}>
            <span className="text-xl font-heading font-bold whitespace-nowrap">韩漫网站</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                  location.pathname === link.to ? 'text-primary-500' : textClass
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textClass}`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 text-sm font-medium border-b border-background-100 cursor-pointer transition-colors hover:bg-primary-50 hover:text-primary-600 ${
                  location.pathname === link.to ? 'text-primary-500 bg-primary-50' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}